
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";

const About = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow">
        {/* Hero Section */}
        <section className="bg-sage-50 py-16 md:py-24">
          <div className="container-custom">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">About Armpits.com</h1>
              <p className="text-lg text-muted-foreground mb-8">
                The internet's premier resource for all things related to armpit health, wellness, and care.
              </p>
            </div>
          </div>
        </section>

        {/* Mission Section */}
        <section className="py-16 bg-background">
          <div className="container-custom">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-3xl font-bold mb-6">Our Mission</h2>
                <p className="text-lg mb-4">
                  At Armpits.com, we believe that underarm health is an essential yet often overlooked aspect of overall wellness. 
                  Our mission is to provide accurate, science-backed information about armpit health while removing 
                  stigma and taboos surrounding this important area of the body.
                </p>
                <p className="text-lg mb-6">
                  We're committed to delivering content that helps you make informed decisions about your personal care, 
                  from choosing the right products to understanding the science behind sweat and odor.
                </p>
                <Button asChild className="mt-2">
                  <Link to="/blog">Explore Our Articles</Link>
                </Button>
              </div>
              <div className="relative rounded-lg overflow-hidden">
                <img 
                  src="/lovable-uploads/f35a5d8b-1b82-4cb3-9bc1-7b46a8986876.png" 
                  alt="Armpit care demonstration with shaving cream and razor" 
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Values Section */}
        <section className="py-16 bg-mint-50">
          <div className="container-custom">
            <h2 className="text-3xl font-bold mb-12 text-center">Our Core Values</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-background p-8 rounded-lg shadow-sm">
                <div className="bg-primary/10 w-12 h-12 flex items-center justify-center rounded-full mb-6">
                  <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold mb-3">Scientific Accuracy</h3>
                <p className="text-muted-foreground">
                  We base all our content on peer-reviewed research and expert insights. 
                  Every claim we make is backed by science and carefully cited.
                </p>
              </div>

              <div className="bg-background p-8 rounded-lg shadow-sm">
                <div className="bg-primary/10 w-12 h-12 flex items-center justify-center rounded-full mb-6">
                  <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold mb-3">Actionable Advice</h3>
                <p className="text-muted-foreground">
                  We don't just educate—we provide practical solutions. Our content aims to help 
                  you make immediate improvements to your underarm health.
                </p>
              </div>

              <div className="bg-background p-8 rounded-lg shadow-sm">
                <div className="bg-primary/10 w-12 h-12 flex items-center justify-center rounded-full mb-6">
                  <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold mb-3">Inclusivity</h3>
                <p className="text-muted-foreground">
                  We recognize that armpit health concerns vary across different bodies and skin types. 
                  Our content addresses a diverse range of needs and experiences.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="py-16 bg-sage-50">
          <div className="container-custom">
            <div className="max-w-3xl mx-auto text-center">
              <h2 className="text-3xl font-bold mb-6">Contact Us</h2>
              <p className="text-lg text-muted-foreground mb-8">
                Have questions, suggestions, or want to collaborate with us? We'd love to hear from you!
              </p>
              <div className="flex flex-col sm:flex-row justify-center gap-4">
                <Button>
                  Send Us a Message
                </Button>
                <Button variant="outline">
                  info@fijidigital.com
                </Button>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default About;
